import { render, staticRenderFns } from "./NewMulti.vue?vue&type=template&id=328978ea&scoped=true&"
import script from "./NewMulti.vue?vue&type=script&lang=js&"
export * from "./NewMulti.vue?vue&type=script&lang=js&"
import style0 from "./NewMulti.vue?vue&type=style&index=0&id=328978ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328978ea",
  null
  
)

export default component.exports